import React from 'react'
import Separator from '../../../../../components/pdf/Separator'
import { FOOTER_CHROME_ID } from '../../_shared/pagination'

const footer = [
  { text: 'Rua: Antônio Borges 172, Jardim Chapadão, Campinas - SP' },
  {
    text: 'Telefone: ',
    links: [
      { href: 'tel:1941071003', label: '19-4107-1003' },
      { href: 'tel:1992567950', label: ' / 19-9256-7950' },
      { href: 'tel:1996950260', label: ' / 19-9695-0260' },
      { href: 'tel:1998829819', label: ' / 19-9882-9819' }
    ]
  },
  {
    text: 'E-mail: ',
    links: [
      { href: 'mailto:comercial2@easysolution.net.br', label: 'comercial2@easysolution.net.br' },
      { href: 'mailto:eduardo@easysolution.net.br', label: ' / eduardo@easysolution.net.br' },
      { href: 'mailto:henrique@easysolution.net.br', label: ' / henrique@easysolution.net.br' }
    ]
  },
  {
    text: 'Site: ',
    links: [{ href: 'http://easysolutionservicos.com.br', label: 'http://easysolutionservicos.com.br' }]
  }
]

const Footer = () => {
  return (
    // `id={FOOTER_CHROME_ID}` (motor de paginação real do Sumário, ver
    // `_shared/pagination.js`): mede a altura deste footer para descontá-la do espaço útil
    // de cada página impressa (ele se repete em toda página via `table-footer-group` de
    // `Page.js`, mas na tela aparece só uma vez). Trocado de `<>` para `<div>` só para ter
    // um elemento para medir — sem efeito visual (mesmo fluxo de blocos).
    <div id={FOOTER_CHROME_ID}>
      <Separator weight={10} />
      {footer.map((item, i) => (
        <div key={i} style={{ fontSize: '7pt', fontFamily: 'Arial, sans-serif', textAlign: 'justify', marginTop: 2 }}>
          {item.text}
          {item.links?.map((link, j) => (
            <a
              key={j}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'blue', textDecoration: 'underline' }}
            >
              {link.label}
            </a>
          ))}
        </div>
      ))}
    </div>
  )
}

export default Footer
